var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchMagnifyingGlass(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1678 20.3356C13.931 20.3356 15.5773 19.7621 16.9156 18.8062L21.9501 23.8407C22.1838 24.0744 22.4918 24.1912 22.8104 24.1912C23.5008 24.1912 24 23.6601 24 22.9804C24 22.6617 23.8938 22.3643 23.6601 22.1306L18.6575 17.1174C19.709 15.7366 20.3356 14.0266 20.3356 12.1678C20.3356 7.67499 16.6606 4 12.1678 4C7.66437 4 4 7.67499 4 12.1678C4 16.6606 7.66437 20.3356 12.1678 20.3356ZM12.1678 18.5725C8.65215 18.5725 5.76314 15.6729 5.76314 12.1678C5.76314 8.66277 8.65215 5.76314 12.1678 5.76314C15.6729 5.76314 18.5725 8.66277 18.5725 12.1678C18.5725 15.6729 15.6729 18.5725 12.1678 18.5725Z",
    fill: "#020202"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchMagnifyingGlass);
export default __webpack_public_path__ + "static/media/search-magnifying-glass.88ab98a98164287d87cc0d7ce457bdac.svg";
export { ForwardRef as ReactComponent };